import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AppIconComponent } from '@app/shared/icons/app-icon.component';
import { ToastService } from './toast.service';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-toast-host',
  imports: [AppIconComponent],
  template: `
    @if (toastService.message(); as message) {
      <div
        class="gabali-toast"
        [class.gabali-toast--success]="message.type === 'success'"
        [class.gabali-toast--error]="message.type === 'error'"
        role="status">
        <app-icon
          className="gabali-toast__icon"
          [name]="message.type === 'success' ? 'check_circle' : 'error_outline'"
        />
        <span class="gabali-toast__text">{{ message.text }}</span>
      </div>
    }
  `,
  styles: [
    `
      :host {
        position: fixed;
        left: 50%;
        bottom: 32px;
        transform: translateX(-50%);
        z-index: 2147483647;
        pointer-events: none;
      }
    `,
  ],
})
export class ToastHostComponent {
  protected readonly toastService = inject(ToastService);
}
